import * as constants from "./constants";
import React from "react";

// TextInput component can render some components inside the form input, such as icons.
export const isIconComponent = (
  component: Exclude<React.ReactNode, boolean | null | undefined>,
) => {
  const nodeType = (component as unknown as React.ReactElement).type;
  if (typeof nodeType === "function") {
    return true;
  }
  return false;
};
